import styles from './drawerButton.module.scss'

interface DrawerButtonProps {
  isOpen: boolean
  onClick?: React.MouseEventHandler
}

export const DrawerButton = ({ isOpen, onClick }: DrawerButtonProps) => {
  return (
    <button className={`${styles.drawerBtn} ${isOpen && styles.open}`} onClick={(e) => onClick?.(e)}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="2 0 32 32" fill="none">
        {isOpen ? (
          <path d="M13 14L18 19L23 14" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        ) : (
          <path d="M13 18L18 13L23 18" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        )}
      </svg>
    </button>
  )
}
